export default "__VITE_ASSET__cf6f4ebd__"